import {
  SERVICE_GET_LIST,
  SERVICE_GET_LIST_SUCCESS,
  SERVICE_GET_LIST_ERROR,
  SERVICE_GET_LIST_WITH_FILTER,
  SERVICE_GET_LIST_WITH_ORDER,
  SERVICE_GET_LIST_SEARCH
} from "../actions";

export const getServiceList = items => ({
  type: SERVICE_GET_LIST,
  payload: items
});
export const getServiceListSuccess = items => ({
  type: SERVICE_GET_LIST_SUCCESS,
  payload: items
});

export const getServiceListError = error => ({
  type: SERVICE_GET_LIST_ERROR,
  payload: error
});

export const getServiceListWithFilter = (column, value) => ({
  type: SERVICE_GET_LIST_WITH_FILTER,
  payload: { column, value }
});

export const getServiceListWithOrder = (column, direction = "asc") => ({
  type: SERVICE_GET_LIST_WITH_ORDER,
  payload: { column, direction }
});

export const getServiceListSearch = keyword => ({
  type: SERVICE_GET_LIST_SEARCH,
  payload: keyword
});
